import { Download } from "lucide-react";

export default function ExportExcelButton({
  onClick,
  className = "",
}) {
  return (
    <button
      onClick={onClick}
      className={`
        group
        relative
        overflow-hidden

        inline-flex
        items-center
        justify-center
        gap-2

        h-11
        px-5

        rounded-2xl
        border border-emerald-500/10

        bg-emerald-600
        text-white

        text-sm
        font-medium
        tracking-wide

        shadow-lg
        shadow-emerald-200/50

        transition-all
        duration-300
        ease-out

        hover:-translate-y-1
        hover:bg-emerald-700
        hover:shadow-2xl
        hover:shadow-emerald-300/40

        active:scale-[0.97]

        ${className}
      `}
    >
      {/* Shine Animation */}
      <div className="absolute inset-0 bg-gradient-to-r from-emerald-400/0 via-white/20 to-emerald-400/0 opacity-0 group-hover:opacity-100 group-hover:animate-[shine_1.5s_ease-in-out] pointer-events-none" />

      {/* Glow */}
      <div className="absolute -inset-1 bg-emerald-400/20 blur-xl opacity-0 group-hover:opacity-100 transition duration-500 pointer-events-none" />

      {/* Icon */}
      <div className="relative z-10 flex items-center justify-center w-6 h-6 rounded-lg bg-white/15 group-hover:translate-y-0.5 transition-transform duration-300">
        <Download
          size={15}
          className="group-hover:translate-y-0.5 transition-transform duration-300"
        />
      </div>

      {/* Text Desktop */}
      <span className="relative z-10 hidden sm:inline">
        Export Excel
      </span>

      {/* Text Mobile */}
      <span className="relative z-10 sm:hidden">
        Export
      </span>
    </button>
  );
}
